import React from 'react'

// react redux
import { connect } from "react-redux";

// themes
import Theme1 from './Themes/AddressesTheme1/Addresses'

function Addresses(props) {
    // props
    const {
        globalAppTheme,
    } = props

    return (
        <React.Fragment>
            {
                globalAppTheme === 'theme1' ? (
                    <Theme1 parentProps={props} />
                ) : null
            }
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//         func: param => dispatch(func(param)),
//     };
// };

export default connect(getDataFromStore, null)(Addresses);